module.exports = __webpack_public_path__ + "img/OGVD_2_1_D.f9e07353.png";